import installCanadaPermanentTime from "./canadaPermanentTime"

installCanadaPermanentTime()
